<template>
  <section class="section-b-space learn-about">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-5">
          <div class="about-left">
            <div>
              <h2>{{ _T(bannerHeading) }}</h2>
              <h6>{{ _T(bannerText) }}</h6>
            </div>
          </div>
        </div>
        <div class="col-md-7">
          <div
            class="about-right"
            :style="{ backgroundImage: `url(${bannerImage})` }"
          >
            <!-- <div>
              <div class="pulsating-circle">
                <img src="/img/video.svg" alt="" />
                <div class="animate-circle-1"></div>
                <div class="animate-circle-2"></div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'BannerPart',
  props: {
    bannerHeading: {
      type: String,
      default: '',
    },
    bannerText: {
      type: String,
      default: '',
    },
    bannerImage: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters(['_T']),
  },
}
</script>

<style lang="scss">
.learn-about {
  padding: $px40 $px25;
  .row {
    margin: 0;
    > div {
      padding: 0;
      .about-left {
        background-color: $color-primary;
        line-height: $px22;
        color: $white;
        text-transform: capitalize;
        border-radius: $px10 0 0 $px10;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        position: relative;
        z-index: 1;
        overflow: hidden;
        img {
          position: absolute;
          right: -$px62;
          bottom: -$px70;
          z-index: -1;
        }
        h2 {
          text-transform: capitalize;
        }
        h6 {
          margin-bottom: 0;
        }
      }
      .about-right {
        border-radius: 0 $px10 $px10 0;
        overflow: hidden;
        background-image: url(/images/about/1.jpg);
        background-size: cover;
        background-repeat: no-repeat;
        height: $px400;
        width: 100%;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 0;
        &::after {
          position: absolute;
          content: '';
          width: 100%;
          height: 100%;
          background: linear-gradient(
            0deg,
            rgba(0, 0, 0, 0.08),
            rgba(0, 0, 0, 0.08)
          );
          top: 0;
          right: 0;
          z-index: -1;
        }
        .pulsating-circle {
          position: relative;
          z-index: 1;
          cursor: pointer;
          .animate-circle-1 {
            position: absolute;
            content: '';
            top: -$px8;
            right: -$px8;
            height: $px90;
            width: $px90;
            z-index: 10;
            border: $px21 solid rgba($white, 0.65);
            border-radius: 100%;
            animation: heartbit 3s ease-out;
            animation-iteration-count: infinite;
            z-index: -1;
          }
          .animate-circle-2 {
            position: absolute;
            content: '';
            top: -$px33;
            right: -$px33;
            height: $px140;
            width: $px140;
            z-index: 10;
            border: $px25 solid rgba($white, 0.3);
            border-radius: 100%;
            animation: heartbit 3s ease-out;
            animation-iteration-count: infinite;
            z-index: -1;
          }
        }

        @keyframes heartbit {
          0% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.2);
          }
          100% {
            transform: scale(1.3);
          }
        }
      }
    }
  }
}
@media (max-width: 1199px) {
  .row {
    > div {
      .about-right {
        .pulsating-circle {
          transform: scale(0.8);
        }
      }
    }
  }
}
@media (max-width: 1199px) {
  .learn-about {
    .row {
      > div {
        .about-right {
          .pulsating-circle {
            transform: scale(0.8);
          }
        }
      }
    }
  }
}
@media (max-width: 991px) {
  .learn-about {
    padding: $px20 0;
    .row {
      > div {
        .about-right {
          height: $px360;
        }
        .about-left {
          img {
            width: 50%;
          }
        }
      }
    }
  }
}
@media (max-width: 767px) {
  .learn-about {
    .row {
      > div {
        .about-left {
          z-index: 1;
          background-color: $transparent;
          position: absolute;
          top: $px58;
          left: $px30;
          overflow: inherit;
          h2 {
            margin-bottom: 0;
          }
          img {
            display: none;
          }
        }
        .about-right {
          height: $px250;
          border-radius: $px10;
          .pulsating-circle {
            transform: scale(0.4);
          }
        }
      }
    }
  }
}
@media (max-width: 575px) {
  .learn-about {
    .row {
      > div {
        .about-left {
          left: $px15;
        }
      }
    }
  }
}
</style>
